import {Dropdown} from './dropdown';

export enum Language {
  FRENCH = 'French',
  ENGLISH = 'English',
  UNKNOWN = 'Unknown',
}

export type SupportedLanguageCode = 'fr' | 'en';

export const getLanguageFromCode = (code: SupportedLanguageCode): Language.ENGLISH | Language.FRENCH => {
  return code === 'en' ? Language.ENGLISH : Language.FRENCH;
};

export const getCodeFromLanguage = (language: Language): SupportedLanguageCode => {
  return language === Language.ENGLISH ? 'en' : 'fr';
};

export const APP_LANGUAGE_HEADER_KEY = 'x-app-language';

const LANGUAGE_OPTIONS_FR: Dropdown<Language>[] = [
  {name: 'Français', value: Language.FRENCH},
  {name: 'Anglais', value: Language.ENGLISH},
];

const LANGUAGE_OPTIONS_EN: Dropdown<Language>[] = [
  {name: 'French', value: Language.FRENCH},
  {name: 'English', value: Language.ENGLISH},
];

export const LANGUAGE_OPTIONS = {
  en: LANGUAGE_OPTIONS_EN,
  fr: LANGUAGE_OPTIONS_FR,
};
